import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

export const US_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY', 'DC',
];

export interface StateSelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  sx?: any;
}

export const StateSelect: React.FC<StateSelectProps> = ({ 
  value, 
  onChange, 
  disabled,
  error,
  helperText,
  required,
  sx,
}) => {
  return (
    <Autocomplete
      options={US_STATES}
      value={value || null}
      onChange={(_, newValue) => onChange(newValue || '')}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          label="State"
          variant="outlined"
          error={error}
          helperText={helperText}
          fullWidth
          required={required}
          sx={sx}
          disabled={disabled}
        />
      )}
    />
  );
};
